import { useTranslation } from '@wlb/shared/i18n/useTranslation';
import './sample-notice.css';

/**
 * Marks a screen whose records are placeholders because the endpoints behind it
 * do not exist yet. It is deliberately loud and always visible: an operator
 * must never mistake sample rows for live community data.
 */
export function SampleNotice() {
  const { t } = useTranslation('admin');

  return (
    <div className="sample-notice" role="note">
      <span className="sample-notice__badge">{t('sample.badge')}</span>
      <div className="sample-notice__body">
        <p className="sample-notice__title">{t('sample.title')}</p>
        <p className="sample-notice__message">{t('sample.message')}</p>
      </div>
    </div>
  );
}
